<template>
  <base-material-card
    icon="mdi-account-arrow-left-outline"
    title="Teams"
    class="px-5 py-3"
    style="position: relative"
  >
    <v-btn
      color="green"
      dark
      small
      absolute
      top
      right
      fab
      @click.stop="addDialog= true"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-data-table
      :value="selected"
      :headers="headers"
      :items="teams"
      :item-class="itemRowBackground"
    >
      <template
        v-slot:item.action="{item}"
      >
        <Fragment>
          <v-icon

            medium
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>

          <v-icon

            medium
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </Fragment>
      </template>
    </v-data-table>

    <v-dialog
      v-model="addDialog"
      max-width="800"
      persistent
    >
      <v-card title="New Team">
        <v-form
          ref="newItemForm"
          @submit.prevent="save(editedItem)"
        >
          <v-container>
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.name"
                    :rules="[() => !!editedItem.name || 'This field is required']"
                    label="Name"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="editedItem.code"
                    :rules="[() => !!editedItem.code || 'This field is required']"
                    label="Code"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-divider />
                  <h3 class="mb-4">Default Shift Schedule</h3>
                  <shift-schedule-selector
                    v-model="editedItem.schedules"
                    :week-days="weekDays"
                    :team="editedItem.code"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click.stop="close">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                type="submit"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
  </base-material-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import { M_ADD_TEAM, M_CREATE_MANY_TEAMS, M_DELETE_TEAM, M_UPDATE_TEAM, Q_GET_TEAMS } from '@/gql/team'
  import ShiftScheduleSelector from '@/components/shift/ShiftScheduleSelector'
  import moment from 'moment'
  const weekDays = [1, 2, 3, 4, 5, 6, 0].map(d => ({ key: d, value: moment().set('day', d).format('ddd') }))
  export default {
    name: 'Users',
    components: { ShiftScheduleSelector },
    data: () => ({
      addDialog: false,
      editedIndex: -1,
      editedItem: { schedules: weekDays.map(d => ({ weekDay: d.key, shift: {}, code: `$${d.key}` })) },
      defaultItem: { schedules: weekDays.map(d => ({ weekDay: d.key, shift: {}, code: `$${d.key}` })) },
      downloading: false,
      filename: '',
      bookType: 'xlsx',
      weekDays: weekDays,

      headers: [
        // { text: 'ID', value: 'id' },
        { text: 'Team Name', value: 'name' },
        { text: 'Code', value: 'code' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
    }),
    computed: {
      ...mapGetters([
        'company', 'teamFull', 'roles', 'user', 'team',
      ]),

    },
    methods: {
      handleDownload () {
        this.downloadLoading = true
        this.filename = `Tik Teams ${this.company} ${this.teamFull && this.teamFull.name}`
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['CurrentTeam', 'Name', 'Code']
        const filterVal = ['currentTeam', 'name', 'code']
        const list = _.orderBy(this.teams, ['currentTeam', 'code', 'name'], ['asc', 'desc', 'asc'])
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        })
        this.downloadLoading = false
      })
      },
      formatJson (filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          if (typeof v[j] === 'number') {
            return +v[j].toFixed(1)
          }

          return v[j]
        }))
      },
      itemRowBackground: function (item) {
        // console.log('class', item)
        return item.status === 'Inactive' ? 'inactive' : ''
      },
      handleUploadSuccess ({ results, header }) {
        // this.tableData = results
        // this.tableHeader = header

        const okResults = results.map(r => _.pick(r, ['name', 'code', 'currentTeam']))
        // console.log(okResults)
        this.createTeams(okResults)
      },
      beforeUpload (file) {
        const isLt1M = file.size / 1024 / 1024 < 1

        if (isLt1M) {
          return true
        }
      },
      createMany (records) {
        this.$apollo.mutate({
          mutation: M_CREATE_MANY_TEAMS,
          // Parameters
          variables: {
            records,
          },
          update: (store, { data: { createTeams } }) => {
            // Read the data from our cache for this query.
            const data = store.readQuery({
              query: Q_GET_TEAMS,

            })
            // Add our tag from the mutation to the end
            data.teams.push(...createTeams)
            // Write our data back to the cache.
            store.writeQuery({
              query: Q_GET_TEAMS,


              data,
            })
          },
          // Optimistic UI
          // Will be treated as a 'fake' result as soon as the request is made
          // so that the UI can react quickly and the user be happy
          optimisticResponse: {
            __typename: 'Mutation',
            createTeams: {
              records,
            },
          },
        }).then((data) => {
          // this.selected = []

          this.$toast.info(`${records.length} New Items Added`)
        // Result
        //  console.log(data)
        }).catch((error) => {
          // Error
          console.error(error)
          this.$toast.error('Something went wrong when add new items')
        // We restore the initial user input
        // this.editedItem = m
        })
      },
      createOne (item) {
        this.$apollo.mutate({
          mutation: M_ADD_TEAM,
          // Parameters
          variables: {
            ...item
          },
          update: (store, { data: { createTeam } }) => {
            // console.log('updated')

            // Read the data from our cache for this query.
            const data = store.readQuery({
              query: Q_GET_TEAMS,


            })

            // Add our tag from the mutation to the end
            data.teams = [...data.teams, createTeam]
            //  console.log('created', createGroup, data)
            //
            // // Write our data back to the cache.
            // store.writeQuery({
            //   query: Q_GET_NEW_MEMBERS,
            //   variables: {
            //
            //     where: {
            //       currentTeam: this.team,
            //     },
            //
            //   },
            //   data,
            // })

            // data.newMembers = data.newMembers.filter(t => {
            //   return +t.id !== 12
            // })
            // console.log('aff',data.timeRecords)
            store.writeQuery({
              query: Q_GET_TEAMS,

              data,
            })

          // const data2 = store.readQuery({
          //   query: Q_GET_NEW_MEMBERS,
          //   variables: {
          //
          //     where: {
          //       currentTeam: this.team,
          //     },
          //
          //   },
          //
          // })
          //
          // console.log({ data2 })
          },

          optimisticResponse: {
            __typename: 'Mutation',
            createTeam: {
              id: 9999,
              code: ' ',
              currentTeam: this.team,
              ...item,
              __typename: 'Team',
            },
          },
        }).then((data) => {
          // this.selected = []
          this.$toast.info('New Record Added')
        // Result
        //  console.log(data)
        }).catch((error) => {
          // Error
          this.$toast.error('Something went wrong when adding a record')

        // We restore the initial user input
        // this.editedItem = m
        })
      },
      update (item) {
        // const updatedRecord = _.pick(this.editedItem, ['id', 'clockIn', 'clockOut', 'date', 'lunchIn', 'lunchOut'])
        item.id = +item.id
        // console.log(updatedRecord,this.editedItem)
        this.$apollo.mutate({
          mutation: M_UPDATE_TEAM,
          variables: { ...item },
          update: (store, { data: { updateTeam } }) => {
            if (updateTeam) {
              // Read the data from our cache for this query.
              const data = store.readQuery({
                query: Q_GET_TEAMS,

              })

              const itemX = data.teams.find(t => +t.id === updateTeam.id)
              // console.log({ updateNewMember, data })

              // toggledTodo.is_completed = !todo.is_completed;
              for (const key of Object.keys(updateTeam)) {
                // member.fullName = item.firstName + item.fatherName + item.grandFatherName
                itemX[key] = updateTeam[key]
              }

              // console.log(data)

              store.writeQuery({
                query: Q_GET_TEAMS,

                data,
              })
            }
          },
          optimisticResponse: {
            __typename: 'Mutation',
            updateTeam: {
              __typename: 'Team',
              ...item,
            },
          },

        }).then(d => {
          this.$toast.info('Record Updated')
        // this.selected = []
        }).catch((error) => {
          // console.log('updateE',error)
          this.$toast.error('Sorry,failed to update the record')
        })
      },
      deleteOne (id) {
        this.$apollo.mutate({
          mutation: M_DELETE_TEAM,
          variables: {
            where: { id },
          },
          update: (store, { data: { deleteTeam } }) => {
            // console.log('aff',deleteTimeRecord)

            const data = store.readQuery({
              query: Q_GET_TEAMS,

            })
            // console.log('aff', data, id)
            data.teams = data.teams.filter(t => {
              return +t.id !== id
            })
            // console.log('aff',data.timeRecords)
            store.writeQuery({
              query: Q_GET_TEAMS,

              data,
            })
          },
          optimisticResponse: {
            __typename: 'Mutation',
            deleteTeam: {
              id,
            },
          },
        },
        ).then(() => {
          this.$toast.info('Record Deleted')
        //  this.selected = []
        })
      },
      close () {
        this.addDialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      editItem (item) {
        // console.log(item)
        this.editedIndex = this.teams.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.schedules = item.schedules || weekDays.map(d => ({ weekDay: d.key, shift: {}, code: `$${d.key}` }))
        // console.log(this.editedItem)
        this.addDialog = true
      },
      deleteItem (item) {
        //  console.log({ item })
        // const index = this.timeRecords.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.deleteOne(+item.id)
      },
      save (item) {
        this.close()
        if (this.editedIndex > -1) {
          this.update({ ...item, schedules: item.schedules })
        } else {
          this.createOne(item)
        }
      },

    },
    apollo: {
      teams: {
        query: Q_GET_TEAMS,

      },

    },

  }
</script>

<style   >
.inactive {
  /*background-color: rgb(215,215,44);*/
  text-decoration: line-through !important;
}
</style>
